/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_CURRENT_DISPLAY_OBJ_PROVIDER =
  'GET_CURRENT_DISPLAY_OBJ_PROVIDER';
export const GET_REBATE_PROGRAM_LIST_PROVIDER =
  'GET_REBATE_PROGRAM_LIST_PROVIDER';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_ERROR_MSG_PROVIDER = 'GET_ERROR_MSG_PROVIDER';
export const GET_REBATE_PROGRAM_NAME_PROVIDER =
  'GET_REBATE_PROGRAM_NAME_PROVIDER';
export const SET_REFRESH_DATA_PROVIDER = 'SET_REFRESH_DATA_PROVIDER';
export const GET_FROM = 'GET_FROM';
export const SET_REFRESH_DATA_PROVIDER_DISPLAY =
  'SET_REFRESH_DATA_PROVIDER_DISPLAY';
export const SET_DISPLAY_OBJ_PROVIDER = 'SET_DISPLAY_OBJ_PROVIDER';
export const GET_PROVIDER = 'GET_PROVIDER';
export const GET_REFERENCE_DATA_PROVIDER_CLAIMS =
  'GET_REFERENCE_DATA_PROVIDER_CLAIMS';
